export default __webpack_public_path__ + "cd8725ada729a6937236668408507f1c.png";